import React, { useMemo } from 'react';
import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ByMedia } from '@this/shared/ui/other/by_media';

interface Props {
  title: string;
  breadcrumbs?: { [key: string]: string }[];
  utils?: React.ReactNode;
  noBackground?: boolean;
  noBackgroundSp?: boolean;
  children: React.ReactNode;
  backLinkPath?: string;
}

const Main = (props: Props) => {
  const styles = useMemo(() => getStyles(), []);
  return (
    <div className="expenses-content-main">
      <div className="expenses-content-main__header">
        <div>
          <h1 style={styles.title}>{props.title}</h1>
          {props.breadcrumbs ? (
            <ul className="expenses-content-main__breadcrumb">
              <li>
                <Link to="/aiexpense/report_items">home</Link>
              </li>
              {props.breadcrumbs.map((breadcrumb, i: number) => (
                <li key={i}>
                  {breadcrumb.link ? <Link to={breadcrumb.link}>{breadcrumb.text}</Link> : breadcrumb.text}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
        <div style={styles.utils}>{props.utils}</div>
      </div>
      {props.backLinkPath && (
        <div className="expenses-content-main__back-link-wrapper">
          <BackLink to={props.backLinkPath}>&lt; 一覧に戻る</BackLink>
        </div>
      )}
      <ByMedia>
        {matches =>
          matches.sm ? (
            <div
              style={styles.contentMainBody(props.noBackgroundSp, true)}
              className="expenses-content-main__body"
            >
              {props.children}
            </div>
          ) : (
            <div style={styles.contentMainBody(props.noBackground)} className="expenses-content-main__body">
              {props.children}
            </div>
          )
        }
      </ByMedia>
    </div>
  );
};

export const BackLink: React.FC<LinkProps> = ({ style, ...props }) => (
  <Link {...props} style={{ display: 'inline-block', color: '#2592C8', fontSize: '14px', ...style }} />
);

const getStyles = () => ({
  utils: { display: 'flex', alignItems: 'center', gap: '16px' },
  title: {
    fontSize: '1.6em',
    fontWeight: 'bold' as const,
    margin: 0
  },
  contentMainBody: (noBackground?: boolean, isMobile = false): React.CSSProperties => ({
    background: noBackground ? 'transparent' : undefined,
    padding: noBackground ? '0' : isMobile ? '20px' : 'calc(32 / 1440 * 100%)',
    borderRadius: noBackground ? undefined : '4px',
    boxShadow: noBackground ? undefined : '0 0 12px 0 rgba(0, 0, 0, 0.05)',
    ...(isMobile && {
      width: noBackground ? undefined : 'calc(100vw - 30px)',
      display: 'flex' as const,
      alignItems: 'center' as const,
      flexDirection: 'column' as const,
      marginBottom: '24px'
    })
  })
});

export default Main;
